import AirportLink from "./AirportLink";

export default function CountryColumn({ country }) {
  if (!country || !country.Airports || country.Airports.length === 0) {
    return null;
  }

  return (
    <div className="flex w-full break-inside-avoid flex-col gap-4">
      {/* Country Name */}
      <span className="border-border text-foreground border-b pb-2 text-xl font-semibold">
        {country.CountryName}
      </span>

      {/* Airports List */}
      <div className="flex flex-col gap-4">
        {country.Airports.slice(0, 11).map((airport, index) => (
          <AirportLink
            key={`${airport.Code}-${index}`}
            airport={{
              code: airport.Code,
              name: airport.Name,
              slug: airport.FlightSlug?.Slug,
            }}
          />
        ))}
        {/* burası sıtkıların dönüşüne göre ayrlanacak */}
        {country.Airports.length > 11 && (
          <div className="pt-2 text-xs text-gray-500">
            +{country.Airports.length - 11} havalimanı daha...
          </div>
        )}
      </div>
    </div>
  );
}
